import React from 'react'

import { Box, Typography } from "@mui/material"
import { AppProviderChips } from "@components"


export default function mainProviderColumn() {

	return {
		name: 'mainProviderNames',
		label: 'Main Provider',
		options: {
			setCellProps: () => ({ sx: { maxWidth: 100 } }),
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				}}>
				{!!value?.length ? <AppProviderChips providers={value} sx={{ justifyContent: 'center' }}/> : <Typography>Any</Typography>}
			</Box>,
		}
	}
}